import { Component, OnInit, Output, Input, EventEmitter, ViewChildren, QueryList, ElementRef, ViewChild } from "@angular/core";
import { GeoLocationModelService } from "./geolocation.model.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { ApplicationModel } from "app/core/models/application.model";
import { KeyPressConstants } from "app/core/vo/app-constants";
import { BaseView } from "../base-view";
import { LocationVO } from "app/core/vo/geo-location";
@Component({
  selector: "app-geolocation",
  templateUrl: "./geolocation.component.html",
  styleUrls: ["./geolocation.component.css"],
})
export class GeolocationComponent extends BaseView implements OnInit {
  @Output() stateSelected: EventEmitter<string> = new EventEmitter();
  //@Input() textDirection:string;
  @ViewChildren("radioWithLoc") radioWithLoc: QueryList<ElementRef>;
  @ViewChild("locSelectClosed") locSelectClosed: ElementRef;
  @ViewChild("iagree") iagree: ElementRef;
  @ViewChildren("dropdownWithLoc") stateDropdown: QueryList<ElementRef>

  private dialogueHeaderText = "";
  private selectedLocation = "";
  public currentIndex = -1;
  public sIndex: number = null;

  constructor(private geoLocationModel: GeoLocationModelService) {
    super();
    this.geoLocationModel.singleLocEvent.subscribe((data) => {
      if (data === "singleLocation loaded") {
        this.clickHandler(this.geoLocationModel.selectedGeoLocation);
        this.iAgreeClickHandler();
      }
    });
  }

	ngOnInit() {}

  public get flowDirection() {
    return ApplicationModel.instance.flowDirection;
  }

  public get textDirection() {
    return ApplicationModel.instance.textDirection;
  }

  private clickHandler(selectedGeoLocation: LocationVO) {
    this.geoLocationModel.selectedGeoLocation = selectedGeoLocation;
    TrackingManager.instance.trackingVO.geoLocation = selectedGeoLocation.id;
    this.dialogueHeaderText =
      this.geoLocationModel.dialogueHeaderText + " " + selectedGeoLocation.label;
    this.selectedLocation = selectedGeoLocation.label;
    
    this.geoLocationModel.locationList.forEach((element,index)=>{
      if(element.label === this.selectedLocation){
        this.sIndex = index;
      }
    });
    /*this.geoLocationModel.showGeoLocation = false;

    this.stateSelected.emit('');*/
    this.geoLocationModel.isConfirmationScreen = true;
    this.geoLocationModel.showDropdown = false;
    setTimeout(() => {
      this.iagree.nativeElement.focus();
    }, 550);
  }

	private iAgreeClickHandler() {
		//this.geoLocationModel.selectedGeoLocation = location;
		this.geoLocationModel.showGeoLocation = false;
		this.geoLocationModel.hideGeolocation = true;

    this.stateSelected.emit("");
  }
  private showDropdownoption() {
    if (this.geoLocationModel.showDropdown === true) {
      this.geoLocationModel.showDropdown = false;
    } else {
      this.geoLocationModel.showDropdown = true;
    }
  }
  private backClickHandler() {
    this.geoLocationModel.isConfirmationScreen = false;
    setTimeout(() => {
      this.locSelectClosed.nativeElement.focus();
    }, 300);
  }
  public onKeyClick(event){    
    if ((event.shiftKey && event.code == KeyPressConstants.ARROWUP) || (event.ctrlKey && event.code == KeyPressConstants.ARROWUP)) {
        event.preventDefault();      
    }      
  } 
  
  //function use -> to navigate dropdown by using arrow keys
  //parameters -> event=>keydown, fromBtn=>wether this function is calling from dropdown btn or from dropdown option
  public accessDropdown(event, fromBtn: boolean){
    if(event.key === KeyPressConstants.ARROWDOWN || event.key === KeyPressConstants.ARROWUP){
      event.preventDefault();
    }
    this.navigateDropdown(event, fromBtn, this.geoLocationModel.showDropdown, this.locSelectClosed, this.stateDropdown, this.geoLocationModel.locationList, this.sIndex);
    this.geoLocationModel.showDropdown = this.getShowDropdown();
  }
}
